export default {
  apiVersion: 2,
  development: {
    accessToken: '3dafee19989188bfa40e8cd1f0187192',
    url: 'http://olifa.dev.moya.is/_/moya/pilot/api',
  },
  staging: {
    accessToken: '3dafee19989188bfa40e8cd1f0187192',
    url: 'https://api.olifapizzeria.is/_/moya/pilot/api',
  },
  production: {
    accessToken: '3dafee19989188bfa40e8cd1f0187192',
    url: 'https://api.olifapizzeria.is/_/moya/pilot/api',
  },
};
